var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4870_7257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5807 14.5625C11.5807 15.0544 11.1819 15.4531 10.6901 15.4531C10.1982 15.4531 9.79944 15.0544 9.79944 14.5625C9.79944 14.0706 10.1982 13.6719 10.6901 13.6719C11.1819 13.6719 11.5807 14.0706 11.5807 14.5625Z",
    fill: "#6F6F6F",
    stroke: "#4C4C4C",
    strokeWidth: 0.09375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6901 11.75V11.125C12.0705 11.125 13.1901 10.1453 13.1901 8.9375C13.1901 7.72969 12.0705 6.75 10.6901 6.75C9.30959 6.75 8.19006 7.72969 8.19006 8.9375V9.25",
    stroke: "#6F6F6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6901 18C14.8322 18 18.1901 14.6421 18.1901 10.5C18.1901 6.35786 14.8322 3 10.6901 3C6.54793 3 3.19006 6.35786 3.19006 10.5C3.19006 14.6421 6.54793 18 10.6901 18Z",
    stroke: "#6F6F6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4870_7257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.690063 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/SupportIcon.2117245d71cd330c7d3858afd96fa16f.svg";
export { ForwardRef as ReactComponent };